import type { TInputModifier } from '@frontend/pole-ui/lib/components/BaseFormFieldContainer'
import type { IFeedbackFormField } from './interfaces'
import { EFieldName } from './interfaces'

export const fieldModifiers: TInputModifier[] = []

export const fields: IFeedbackFormField[] = [
  { fieldName: EFieldName.fullName },
  { fieldName: EFieldName.phone, type: 'tel', isFieldRequired: (errors, values) => !(!errors?.email && values.email) },
  {
    fieldName: EFieldName.email,
    type: 'email',
    isFieldRequired: () => false,
  },
  { fieldName: EFieldName.message, type: 'textArea' },
]

export const requestStatusName = 'sendFeedback'
